const pagination = {
  fr: {
    pagination: {
      goToPage: 'Aller à la page',
      currentPage: '{{currentPage}} sur {{numberOfPages}}',
    },
  },
  en: {
    pagination: {
      goToPage: 'Go to page',
      currentPage: '{{currentPage}} of {{numberOfPages}}',
    },
  },
};

export default pagination;



// WEBPACK FOOTER //
// ./src/statsradio/modules/pagination/i18n/pagination.js